<style lang="scss" scoped>
.table {
  background: #fff;
  height: 300px;
  margin-top: 20px;
  padding: 20px;
}
/deep/ .el-input {
  width: 400px;
  margin-right: 5px;
}
.line {
  height: 40px;
  line-height: 40px;
  margin-bottom: 20px;
  display: flex;
  > span {
    display: inline-block;
    width: 120px;
    text-align: right;
    margin-right: 10px;
  }
  i {
    font-size: 24px;
    color: #32c5ff;
    line-height: 40px;
  }
}
p {
  color: #606266;
  margin-left: 130px;
  font-size: 14px;
  margin-top: -15px;
}
</style>

<template>
  <div>
    <alert>
      <div>1、公众号分为订阅号、服务号，根据微信公众平台的接口规则，不同类型的公众号可使用不同的功能；如果是认证的服务号则下面的全部功能均可使用！</div>
      <div>2、认证：在公众平台后台提交企业资料并向微信支付300元的认证费用并审核通过，叫公众号认证；如果公众号没有认证则只能使用下面的部分功能！</div>
      <div>3、该公众号（上海零动）是已认证的服务号，下面的全部功能均可使用！</div>
    </alert>
    <div class="table">
      <div class="line">
        <span>商户号</span>
        <el-input v-model="form.no"></el-input>
        <el-tooltip class="item" effect="dark" content="提示:商户号" placement="right">
          <i class="el-icon-question"></i>
        </el-tooltip>
      </div>
      <div class="line">
        <span>密钥</span>
        <el-input v-model="form.secret"></el-input>
        <el-tooltip class="item" effect="dark" content="提示:密钥" placement="right">
          <i class="el-icon-question"></i>
        </el-tooltip>
      </div>
      <div class="line">
        <span>支付授权目录</span>
        <el-input v-model="form.url" :disabled="true"></el-input>
        <el-tooltip class="item" effect="dark" content="提示:不可修改" placement="right">
          <i class="el-icon-question"></i>
        </el-tooltip>
      </div>
      <p>请复制授权目录URL，登录微信商户平台->开发配置->公众号支付->支付授权目录 中设置</p>
    </div>
    <div class="clearfix">
      <el-button type="primary" class="fr mt20">保存</el-button>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  computed: {},
  data() {
    return {
      form: {
        no: '',
        secret: '',
        url: 'www.baidu.com',
      },
    };
  },
  mounted() {},
  methods: {},
};
</script>
